import React, { useEffect, useState } from "react";
import styles from "MODULES/parts/components/Detail/styles";
import PropTypes from "prop-types";
import api from "APP_ROOT/api";
import { toastr } from "react-redux-toastr";
import Form from "./Form";

export default function Update({ close, lineItem }) {
  const [repairQuote, setRepairQuote] = useState(null);
  useEffect(
    () => {
      api.repairQuotes.show(lineItem.repair_quote_id).then(({ data }) => {
        setRepairQuote(data);
      });
    },
    [lineItem.repair_quote_id]
  );

  if (!repairQuote) return null;
  const { onSubmit } = useOnSubmit(close, repairQuote);
  const {
    company: _company,
    contact: _contact,
    ...initialValues
  } = repairQuote;

  return (
    <div className="panel panel-default" style={styles.container}>
      <div className="panel-body">
        <button className="close" type="button" onClick={close}>
          <span>
            <i className="fa fa-close" />
          </span>
        </button>
        <h4 className="modal-title" style={styles.title}>
          Update Repair Station Quote
        </h4>
        <Form
          close={close}
          initialValues={initialValues}
          repairQuote={repairQuote}
          onSubmit={onSubmit}
          modal={false}
        />
      </div>
    </div>
  );
}

Update.propTypes = {
  close: PropTypes.func.isRequired,
  lineItem: PropTypes.shape({}),
  repairQuote: PropTypes.shape({
    id: PropTypes.number,
    company: PropTypes.shape({}),
    contact: PropTypes.shape({})
  })
};

function useOnSubmit(close, repairQuote) {
  const onSubmit = async data => {
    const { data: quote } = await api.repairQuotes.update(repairQuote.id, data);

    toastr.success("Success", `${quote.code} successfully updated.`);

    close({ sendRfq: data.sendRfq, ...quote });
  };

  return { onSubmit };
}



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/RepairQuotes/Update/Update.jsx